module.exports = __webpack_public_path__ + "img/engineer.42843163.png";